var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 11.5a5 5 0 0 0 5-5v-5a1 1 0 0 0-2 0v5a3 3 0 1 1-6 0v-5a1 1 0 0 0-2 0v5a5 5 0 0 0 5 5Zm5 2H1a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z",
  fill: "currentColor"
})));

export default SvgUnderline;